export default "__VITE_ASSET__LmqSjoSj__"